import { useTranslation } from 'react-i18next';
import logo from '@/assets/logo.svg';

interface DashboardHeaderProps {
  title: string;
  userName?: string;
}

export const DashboardHeader = ({ title, userName }: DashboardHeaderProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="mb-8 mt-6">
      <div className="flex items-center gap-4 mb-2">
        <img src={logo} alt="Velox" className="h-10 w-10" />
        <h1 className="text-3xl font-medium text-secondary font-heading">
          {title}
        </h1>
      </div>
      {userName && (
        <p className="text-base text-muted-foreground">
          {t('common.welcome')}, {userName}
        </p>
      )}
    </div>
  );
};
